// const HOST = 'http://localhost:5000/api';
const HOST = 'https://yt-clone-api.onrender.com/api';
export default HOST;
